import LegalPage from "@/pages/legal/LegalPage";

export default function PrivacyPolicy() {
  return (
    <LegalPage title="Gizlilik Politikası" testId="legal-privacy">
      <div className="rounded-2xl border border-zinc-200 bg-[#faf9ff] p-7">
        <p>
          İşbu gizlilik bildirisi sizleri gizliliğe ilişkin uygulamalarımız konusunda ve bize
          verdiğiniz kişisel bilgilerinizin nasıl kullanıldığı ve korunduğu hakkında bilgilendirmektedir.
          Bu politika (adresi www.entanet.com.tr olan) web sitesine ilişkindir. Web sitemizde üçüncü
          kişilere ait verilebilecek web sitesi linkleri bizim kontrolümüzde olmayıp işbu politika
          kapsamına dahil değildir.
        </p>
      </div>

      <h2 className="font-display text-lg font-bold text-[#101436]">Bilgilerin Paylaşımı</h2>
      <p>
        Sizden toplanan bilgiler başka bir üçüncü tarafa satılmayacak veya kiralanmayacaktır.
        EntaNET, size ait kişisel bilgileri iştirakları, üçüncü taraf acenteleri veya taşeronları ile
        paylaşma hakkını saklı tutar. Üçüncü taraf acenteleri ve taşeronlar, size ait gizli mahiyetteki
        kişisel bilgileri gizlilik ilkesi çerçevesinde saklamayı taahhüt etmek zorunda olup bu bilgileri
        EntaNET için gerçekleştirmekte oldukları hizmetler dışındaki amaçlar için kullanamazlar.
      </p>

      <h2 className="font-display text-lg font-bold text-[#101436]">Kişisel Bilgilere Ulaşılması ve Güncellenmesi</h2>
      <p>
        Kişisel bilgilerinizde zaman zaman oluşabilecek değişiklikler hakkında lütfen bize bilgi veriniz.
        Kişisel bilgileriniz mahkeme emirlerine cevap verilmesi vb. de dahil olmak üzere hukuki işlemler
        için de kullanılabilir.
      </p>

      <h2 className="font-display text-lg font-bold text-[#101436]">Kişisel Bilgilerin Güvenli Biçimde Saklanması</h2>
      <p>
        Bilgilere izinsiz erişimi ve bilgilerin ifşa edilmesini engellemek ve verilerin doğru şekilde
        saklanarak uygun biçimde kullanılmasını sağlamak için EntaNET bütün makul güvenlik önlemlerini alır.
      </p>

      <h2 className="font-display text-lg font-bold text-[#101436]">Çerezler</h2>
      <p>
        Web sitemizde sizlere daha iyi bir deneyim verebilmek amacıyla çerez (cookie)
        kullanılmaktadır. Çerez kullanımına ilişkin detaylı bilgi için Kullanım Politikası
        sayfamızı inceleyebilirsiniz.
      </p>

      <h2 className="font-display text-lg font-bold text-[#101436]">Değişiklikler ve Güncellemeler</h2>
      <p>
        EntaNET, veri sorumlusu olarak gizlilik politikasını kanuna uygun olmak ve kişisel verilerin
        daha iyi korunması şartı ile değiştirme hakkına sahiptir.
      </p>

      <div className="rounded-2xl border border-zinc-200 p-7">
        <h3 className="font-display text-base font-bold text-[#101436]">İletişim</h3>
        <ul className="mt-3 space-y-1.5 text-sm text-gray-600">
          <li><strong>Şirket Unvanı:</strong> ENTA-NET TELEKOMÜNİKASYON VE BİLGİ TEKNOLOJİLERİ TİC. LTD. ŞTİ.</li>
          <li><strong>Adres:</strong> Saray Mah. 106_1 Sok. No:12A Silifke / Mersin</li>
          <li><strong>E-posta:</strong> info@entanet.com.tr</li>
          <li><strong>Telefon:</strong> +90 324 714 17 04</li>
        </ul>
      </div>
    </LegalPage>
  );
}
